import {User} from '@drl/core/auth/models/user.model';

export class NursingNotes {
  id: string;
  note: string;
  logDate: Date;
  patientId: number;
  createdBy: number;
  modifiedBy: number;
  createdOn: Date;
  modifiedOn: Date;
  creator: User;
}
